import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../shared/utility";

export type AuthState = {
  userId: string;
  token: string | null;
  organizationId: string;
  role: "STAFF" | "ADMIN" | "CLIENT" | null;
  error: any | null;
  loading: boolean;
};

type AuthAction = {
  userId: string;
  type: string;
  idToken?: string;
  organizationId?: string;
  role: "STAFF" | "ADMIN" | "CLIENT";
  error?: any;
};

export const initialState: AuthState = {
  userId: "",
  token: null,
  organizationId: "",
  role: null,
  error: null,
  loading: false,
};

const authStart = (state: AuthState, action: AuthAction) => {
  return updateObject(state, { error: null, loading: true });
};

const authSuccess = (state: AuthState, action: AuthAction) => {
  return updateObject(state, {
    userId: action.userId,
    token: action.idToken,
    organizationId: action.organizationId,
    role: action.role,
    error: null,
    loading: false,
  });
};

const authFail = (state: AuthState, action: AuthAction) => {
  return updateObject(state, {
    error: action.error,
    loading: false,
  });
};

const authLogout = (state: AuthState, action: AuthAction) => {
  return updateObject(state, {
    token: null,
    role: null,
    loading: false,
  });
};

const reducer = (state = initialState, action: AuthAction) => {
  switch (action.type) {
    case actionTypes.AUTH_START:
      return authStart(state, action);
    case actionTypes.AUTH_SUCCESS:
      return authSuccess(state, action);
    case actionTypes.AUTH_FAIL:
      return authFail(state, action);
    case actionTypes.AUTH_LOGOUT:
      return authLogout(state, action);

    default:
      return state;
  }
};

export default reducer;
